import { debounce, fetchConfig, handlePurchaseLimitErrors } from '../common'
import { UmgGwp } from './umg-gwp'

class CartItems extends HTMLElement {
  constructor () {
    super()

    this.cart = document.getElementById('cart')

    window.addEventListener('pageshow', this.onHistoryChange.bind(this))
    document.addEventListener('visibilitychange', this.onTabChange.bind(this))
    if (document.querySelector('[data-pause-cart-countdown]')) {
      import('./pause-cart-countdown').then((module) => {
        module.initPauseCartCountdown(this)
      })
    }
  }

  renderContents (parsedState) {
    this.getSectionsToRender().forEach(section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)
        if (document.getElementById(`${section.id}_md`)) {
          document.getElementById(`${section.id}_md`).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)
        }
      } else {
        document.getElementById(`shopify-section-${section.id}`).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)
        if (document.getElementById(`shopify-section-${section.id}_md`)) {
          document.getElementById(`shopify-section-${section.id}_md`).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)
        }
      }
    })
    if (document.querySelector('[data-pause-cart-countdown]')) {
      import('./pause-cart-countdown').then((module) => {
        module.initPauseCartCountdown(this)
      })
    }
  }

  getSectionsToRender () {
    return [
      {
        id: 'header-cart-count',
        section: 'header-cart-count',
        dynamic: false
      },
      {
        id: document.getElementById('cart').dataset.id,
        section: document.getElementById('cart').dataset.id,
        dynamic: true
      }
    ]
  }

  getSectionInnerHTML (html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  setActiveElement (element) {
    this.activeElement = element
  }

  updateQuantity (line, quantity, variantId, qtyChange, gtmContent) {
    // console.log('main cart updating quantity')
    const sections = this.getSectionsToRender().map((section) => section.id)
    const sections_url = window.location.pathname
    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: sections_url
    })

    const pdpQuantitySpinnerId = `.item-quantity quantity-spinner[data-variant-id="${variantId}"]`
    const pdpQuantitySelectorId = `.item-quantity quantity-selector[data-variant-id="${variantId}"]`

    let pdpQuantityInput = null
    // let pdpQuantityInputSections = []
    if (document.querySelector(pdpQuantitySpinnerId)) {
      pdpQuantityInput = document.querySelector(pdpQuantitySpinnerId)
      // pdpQuantityInputSections = pdpQuantityInput.getSectionsToRender().map((section) => section.id)
    } else if (document.querySelector(pdpQuantitySelectorId)) {
      pdpQuantityInput = document.querySelector(pdpQuantitySelectorId)
      // pdpQuantityInputSections = pdpQuantityInput.getSectionsToRender().map((section) => section.id)
    }

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text()
      })
      .then((state) => {
        const parsedState = JSON.parse(state)
        if (parsedState.errors !== undefined) {
          if (pdpQuantityInput) {
            const component_ref = gtmContent.item_component_ref
            const product_data = {
              id: gtmContent.item_id,
              component_ids: component_ref ? component_ref.split(',') : null
            }

            handlePurchaseLimitErrors(product_data, parsedState)
          }
        } else {
          this.renderContents(parsedState)

          if (!Shopify.designMode) {
            const customEvent = {
              currency: window.currentCurrency,
              items: [
                {
                  item_name: gtmContent.item_name,
                  item_id: gtmContent.item_id,
                  item_category: gtmContent.item_collection,
                  item_variant: gtmContent.item_variant,
                  upc: gtmContent.item_upc,
                  price: parseFloat(gtmContent.item_price),
                  quantity: parseInt(gtmContent.quantity)
                }
              ]
            }

            if (window.shop_iso_code === 'DE') {
              const item = {
                ...customEvent.items[0],
                item_brand: gtmContent.item_brand,
                item_sku: gtmContent.item_sku,
                item_group_id: gtmContent.item_group_id,
                category: gtmContent.category
              }

              Object.assign(gtmContent, {
                items: [item]
              })
            }

            if (qtyChange > 0) {
              Shopify.analytics.publish('cart_item_added', customEvent)
            } else {
              Shopify.analytics.publish('cart_item_removed', customEvent)
            }

            if (window.umgGwp !== undefined) {
              // Don't call umg gift with purchase if no gift with purchase data exists
              UmgGwp(this, sections, sections_url)
            }
          }
        }
      }).catch((errors) => {
        console.log('error', errors)
        errors.forEach(error => {
          pdpQuantityInput.showPurchaseLimitErrorMessage(error)
        })
      })
  }

  onHistoryChange (event) {
    if (event.persisted) {
      window.refreshSections(this.getSectionsToRender())
    }
  }

  onTabChange (event) {
    // console.log(event)
    if (!document.hidden) {
      // console.log('Browser tab is visible')
      window.refreshSections(this.getSectionsToRender())
    }
  }
}

customElements.define('cart-items', CartItems)
